"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeModel = exports.IkeMap = exports.IkeCSVMapper = exports.IkeCSV = void 0;
var tslib_1 = require("tslib");
tslib_1.__exportStar(require("./collection"), exports);
tslib_1.__exportStar(require("./form"), exports);
var csv_1 = require("./collection/import/csv");
Object.defineProperty(exports, "IkeCSV", { enumerable: true, get: function () { return csv_1.IkeCSV; } });
var csv_mapper_1 = require("./collection/import/csv.mapper");
Object.defineProperty(exports, "IkeCSVMapper", { enumerable: true, get: function () { return csv_mapper_1.IkeCSVMapper; } });
var collection_1 = require("./collection");
var form_1 = require("./form");
var ike_map_1 = require("./ike.map");
Object.defineProperty(exports, "IkeMap", { enumerable: true, get: function () { return ike_map_1.IkeMap; } });
exports.IkeModel = {
    Collection: new collection_1.IkeModelCollection(),
    Form: new form_1.IkeModelForm()
};
//# sourceMappingURL=index.js.map